import React from "react"
import { PageProps } from "gatsby"
import { useIntl } from "gatsby-plugin-intl"
import * as styles from "./contacts.module.scss"

import Layout from "../../components/Layout/Layout"
import SEO from "../../components/seo"



const Contacts: React.FC<PageProps> = ({ location }) => {
	const intl = useIntl()

	return (
		<Layout location={location}>
			<SEO
				language={intl.locale}
				description={intl.formatMessage({ id: "index.seo.description" })}
				title={intl.formatMessage({ id: "index.seo.title" })}
				pathname={location.pathname}
			/>
			<div className={styles.contacts} />
		</Layout>
	)
}

export default Contacts;
